import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {
  token: {
    authenticated: false,
    expiration: "",
    token: "",
    message: "",
  },
};

const getters = {
  token: (state) => state.token,
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async auth({ commit }, data) {
    return await API.post(`${environment.apiUri}${route.Autenticate}`, data);
  },
};

const mutations = {
  setToken: (state, data) => (state.token = data),
};

export default {
  state,
  actions,
  getters,
  mutations,
};
